import { createFeatureSelector, createSelector } from "@ngrx/store";
import { buildBrandEntity } from "@youm-front/brand/utils/factory";
import {
  brandAdapter,
  brandBgAdapter,
  brandCaptionLowerThirdAdapter,
  brandLogoAdapter,
  brandOverlayAdapter
} from "../reducers";
import { BrandState, BRAND_STORE } from "../store";

const brandState = createFeatureSelector<BrandState>(BRAND_STORE);

const { selectAll: selectAllBrands } = brandAdapter.getSelectors();
const { selectAll: selectAllBrandsLogos } = brandLogoAdapter.getSelectors();
const { selectAll: selectAllBrandsBgs } = brandBgAdapter.getSelectors();
const { selectAll: selectAllBrandsOverlays } =
  brandOverlayAdapter.getSelectors();
const { selectAll: selectAllBrandsCaptionLowerThirds } =
  brandCaptionLowerThirdAdapter.getSelectors();

export const brandGetList = createSelector(brandState, (state: BrandState) => {
  return selectAllBrands(state.brand).map((_) => {
    const logos = selectAllBrandsLogos(state.brandLogo).filter(
      (bl) => bl.brandId === _.id
    );
    const bgs = selectAllBrandsBgs(state.brandBg).filter(
      (bb) => bb.brandId === _.id
    );
    const overlays = selectAllBrandsOverlays(state.brandOverlay).filter(
      (bo) => bo.brandId === _.id
    );
    const captionLowerThirds = selectAllBrandsCaptionLowerThirds(
      state.brandCaptionLowerThird
    ).filter((bc) => bc.brandId === _.id);

    return buildBrandEntity({
      id: _.id,
      title: _.title,
      isDefault: _.isDefault,
      logos,
      bgs,
      overlays,
      captionLowerThirds
    });
  });
});

export const isLoading = createSelector(
  brandState,
  (state: BrandState) => state.brand.isLoading
);
